import { AutoTextSize } from "auto-text-size"
import { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"

import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"

import styles from "./DoorAccessCodeCard.module.css"

function DoorAccessCodeCard(props: PropsWithChildren) {
  const { t } = useTranslation()
  return (
    <article className={styles.card}>
      <Heading level={3}>{t("doorAccessCode.header")}</Heading>
      <Text level={2}>{t("doorAccessCode.description")}</Text>
      <div>
        <AutoTextSize maxFontSizePx={48} mode="boxoneline">
          {props.children}
        </AutoTextSize>
      </div>
    </article>
  )
}

export default DoorAccessCodeCard
